import Segment from 'models/Segment';
import Base from 'models/Base';
import { toEntityList } from 'models/BaseList';

import {
  SEGMENTS_ASYNC_START,
  SEGMENTS_ASYNC_FAIL,
  SEGMENTS_ASYNC_SUCCESS,
  SEGMENT_SELECT,
} from 'actions/segments';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new Segment(),
  list: toEntityList([], Segment),
});

const actionsMap = {
  [SEGMENT_SELECT]: (state, action) => {
    return state.merge({
      loading: false,
      data: new Segment(action.data),
    });
  },
  [SEGMENTS_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [SEGMENTS_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      list: toEntityList(action.data, Segment),
    });
  },
  [SEGMENTS_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
};

export default function segments(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
